import { UserJob } from '../../../lib/interfaces/user';

export const USER_JOB_LABELS: Record<UserJob, string> = {
  [UserJob.DESIGNER]: 'Design',
  [UserJob.MARKETER]: 'Marketing',
  [UserJob.SALES]: 'Vertrieb',
  [UserJob.DEVELOPER]: 'Development',
  [UserJob.TEAMLEADER]: 'Teamleader'
};

export const SELECTABLE_USER_JOBS: UserJob[] = [UserJob.MARKETER, UserJob.DESIGNER, UserJob.SALES, UserJob.DEVELOPER, UserJob.TEAMLEADER];
